import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import useVisibility from 'src/hooks/useVisibility';
import useObserver from 'src/hooks/useObserver';
import buildQuery from '@/components/Dashboard/utils/buildQuery';
import { DASHBOARD_TABS } from '../constants';
import { RANGE_DATE } from '@/components/FilterBar/constants/filtersConstants';

export default function useFetchDashboard() {
  const { isVisible } = useVisibility();
  const { ref, isInViewport } = useObserver();
  const { refreshCount, tabActive, edition } = useSelector(
    (state) => state.DashboardSlice
  );
  const { filters } = useSelector((state) => state.FilterBarSlice);
  const [isStale, setIsStale] = useState(true);
  const isEditing = edition?.active === true;
  const canFetchRef = useRef(false);

  const useFetchOnViewport = (callback, deps = [], options = {}) => {
    const { hasFetched = false } = options;
    useEffect(() => {
      if (isVisible) {
        canFetchRef.current = true;
      }
      setIsStale(true);
    }, [isVisible, filters.selectedIds, ...deps]);

    useEffect(() => {
      canFetchRef.current = true;
      setIsStale(true);
    }, [refreshCount]);

    useEffect(() => {
      if (isEditing && hasFetched) return;
      if (!canFetchRef.current) return;
      if (!isVisible || !isInViewport) return;

      const filtersBlacklist =
        tabActive === DASHBOARD_TABS.PERFORMANCE ? [] : [RANGE_DATE];
      const query = buildQuery(filters.selectedIds, filtersBlacklist);

      callback(query);

      canFetchRef.current = false;
      setIsStale(false);
    }, [
      isEditing,
      hasFetched,
      isVisible,
      isInViewport,
      filters.selectedIds,
      tabActive,
      refreshCount,
      ...deps,
    ]);
  };

  return {
    ref,
    isStale: isStale && !isEditing,
    useFetchOnViewport,
  };
}
